import { render, staticRenderFns } from "./addAdminRole.vue?vue&type=template&id=774425b0&scoped=true"
import script from "./addAdminRole.vue?vue&type=script&lang=js"
export * from "./addAdminRole.vue?vue&type=script&lang=js"
import style0 from "./addAdminRole.vue?vue&type=style&index=0&id=774425b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774425b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('774425b0')) {
      api.createRecord('774425b0', component.options)
    } else {
      api.reload('774425b0', component.options)
    }
    module.hot.accept("./addAdminRole.vue?vue&type=template&id=774425b0&scoped=true", function () {
      api.rerender('774425b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/enterprise/components/addAdminRole.vue"
export default component.exports